import React, { ReactElement } from 'react';

type PageTitleProps = {
    label: string
}

const PageTitle = (props: PageTitleProps) : ReactElement => {
    const {
        label
    } = props;

    return (
        <h1 className="page-title">{label}</h1>
    )
}

export default PageTitle;